/* ===========================================================
   Telefone — normalização e formatação (puro, testável).
   Contrato e banco guardam E.164 ("+5511999998888"); a borda
   normaliza a entrada e a tela formata para exibição / mascara
   para privacidade. Nenhum DDI além do BR (55) no v1.
   Compartilhado entre app e apps/api via ../shared (M1.1);
   o teste continua em src/domain/telefone.test.ts.
   =========================================================== */

const DDI_BR = "55";

/** Dígitos nacionais (DDD + número), no máximo 11; ignora um DDI 55 colado. */
function digitosNacionais(input: string): string {
  const d = input.replace(/\D/g, "");
  // "5511999998888" (13) → tira o DDI; "11999998888" (11) fica como está.
  // DDD nunca passa de 2 dígitos, então só removemos o 55 quando sobra número demais.
  const semDdi = d.length > 11 && d.startsWith(DDI_BR) ? d.slice(2) : d;
  return semDdi.slice(0, 11);
}

/** Formata progressivamente para exibição: "(11) 99999-8888". */
export function formatTelefoneBr(input: string): string {
  const d = digitosNacionais(input);
  if (d.length <= 2) return d;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

/** Celular (11) ou fixo (10) válido. */
export function telefoneBrValido(input: string): boolean {
  return toE164Br(input) !== null;
}

/** Normaliza para E.164 ("+5511999998888") ou null se inválido. */
export function toE164Br(input: string): string | null {
  const nac = digitosNacionais(input);
  if (nac.length < 10 || nac.length > 11) return null;
  return `+${DDI_BR}${nac}`;
}

/** Máscara de privacidade a partir do E.164 → "+55 11 9****-8888". */
export function mascararTelefoneBr(e164: string): string {
  const d = e164.replace(/\D/g, "");
  const nac = d.startsWith(DDI_BR) ? d.slice(2) : d;
  if (nac.length < 10) return e164;
  const ddd = nac.slice(0, 2);
  const num = nac.slice(2);
  // celular preserva o "9" inicial; fixo não tem prefixo visível.
  const ini = num.length === 9 ? num.slice(0, 1) : "";
  const fim = num.slice(-4);
  const oculto = "*".repeat(num.length - ini.length - fim.length);
  return `+${DDI_BR} ${ddd} ${ini}${oculto}-${fim}`;
}
